export function TryPaseJson(text: string) {
  try {
    return JSON.parse(text);
  } catch (e) {
    return null;
  }
}
